import React from "react";
import { Chip } from "@mui/material";

/**
 * Chip colour for each work status used by tasks, action items, punch list
 * and fabrication. Anything not listed shows as a neutral chip.
 */
export const STATUS_CHIP_COLORS = {
  "Not Started": "default",
  Progress: "primary",
  Hold: "warning",
  Completed: "success",
  Delayed: "error",
};

/** A work status as a coloured chip; renders nothing for an empty status. */
export default function StatusChip({ status }) {
  if (!status) return null;
  return (
    <Chip
      label={status}
      size="small"
      color={STATUS_CHIP_COLORS[status] || "default"}
      variant={STATUS_CHIP_COLORS[status] === "default" ? "outlined" : "filled"}
    />
  );
}
